import type { ReactNode } from 'react';

export const symbol_info_i: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M430.5-720.59q-20.5-20.59-20.5-49.5t20.59-49.41q20.59-20.5 49.5-20.5t49.41 20.59q20.5 20.59 20.5 49.5t-20.59 49.41q-20.59 20.5-49.5 20.5t-49.41-20.59Zm14 586.01Q430-149.17 430-170v-380q0-20.83 14.62-35.42Q459.24-600 480.12-600q20.88 0 35.38 14.58Q530-570.83 530-550v380q0 20.83-14.62 35.42Q500.76-120 479.88-120q-20.88 0-35.38-14.58Z"
		/>
	</svg>
);
